export default __webpack_public_path__ + "static/BasisGrotesque-Light-c88bf0d31c2dbdd02af4470ccaef1215.woff";